/// <reference lib="webworker" />
import {ApolloWorkerAdapter} from './apollo.worker.adapter';

const apolloWorkerTest = new ApolloWorkerAdapter();

addEventListener('message', apolloWorkerTest.messageEventListener())
